import BulkDriverSecondaryLocalityApi from "../../services/api/BulkUploadDriverSecondaryLocalityMapping";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk upload driver locality:", err);
}

export const bulkUploadDriverSecondaryLocality = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    const response = await BulkDriverSecondaryLocalityApi.bulkUploadDriverSecondaryLocality(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
      })
    );
    handleError(err);
  }
};